import { MaskLine, Rise } from "@/components/motion/Reveal";
import { INSIGHTS } from "@/data/site";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";
import Seo from "@/seo/Seo";
import { ldBreadcrumb } from "@/seo/seoConfig";

export default function InsightsPage() {
  const { t } = useLang();
  const [feature, ...rest] = INSIGHTS;
  return (
    <div className="pt-40">
      <Seo
        title="Insights · UAE PDPL, VARA, DPDPA, Arbitration, AI Governance"
        description="Long-form legal insights from RPLC UAE partners on UAE PDPL, VARA licensing, DIFC arbitration, DPDPA compliance, ransomware response, AI governance and cross-border M&A."
        path="/insights"
        keywords={["UAE PDPL insights", "VARA licensing 2026", "DIFC arbitration", "DPDPA blog", "AI governance India UAE", "cyber law article Dubai"]}
        jsonLd={ldBreadcrumb([{ name: "Home", path: "/" }, { name: "Insights", path: "/insights" }])}
      />
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <Rise><div className="flex items-center gap-4 mb-10"><span className="accent-bar" /><span className="eyebrow">{t.insights.eyebrow}</span></div></Rise>
        <h1 className="font-serif tracking-tight leading-[0.9] text-[13vw] lg:text-[8vw]">
          <MaskLine delay={0.15}>{t.insights.title1}</MaskLine>
          <MaskLine delay={0.32}><span className="italic-accent">{t.insights.title2}</span></MaskLine>
        </h1>
      </section>

      {/* FEATURED */}
      <section className="mt-24 border-y border-[#141414]">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Rise className="lg:col-span-2">
            <div className="chapter-num">{t.insights.featured}</div>
          </Rise>
          <div className="lg:col-span-10">
            <Rise>
              <div className="flex items-center gap-3 chapter-num mb-4">
                <span>{feature.cat}</span><span>·</span><span>{feature.read}</span>
              </div>
            </Rise>
            <Rise delay={0.05}>
              <Link to={`/insights/${feature.slug}`} className="link-hover">
                <h2 className="font-serif text-4xl lg:text-6xl leading-[1] tracking-tight max-w-4xl">{feature.title}</h2>
              </Link>
            </Rise>
            <Rise delay={0.15}>
              <div className="mt-10 flex items-center justify-between border-t border-[#141414] pt-6">
                <div className="text-[#A19D94]">{feature.author} · <span className="text-[#66635C]">{feature.date}</span></div>
                <Link to={`/insights/${feature.slug}`} className="btn-ghost">{t.insights.read} <ArrowUpRight size={14} strokeWidth={1.5} /></Link>
              </div>
            </Rise>
          </div>
        </div>
      </section>

      {/* GRID */}
      <section className="py-24">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#141414] border border-[#141414]">
            {rest.map((n, i) => (
              <Rise key={i} delay={i * 0.05}>
                <Link to={`/insights/${n.slug}`} className="block bg-[#050505] p-8 lg:p-10 h-full min-h-[380px] flex flex-col justify-between hover:bg-[#0A0A0A] transition-colors duration-500 group">
                  <div>
                    <div className="flex items-center justify-between chapter-num">
                      <span>{n.cat}</span>
                      <span>{n.read}</span>
                    </div>
                    <h3 className="mt-8 font-serif text-2xl lg:text-3xl leading-tight group-hover:text-[#C84C35] transition-colors duration-700">{n.title}</h3>
                  </div>
                  <div className="mt-8 pt-6 border-t border-[#141414] flex items-center justify-between text-sm">
                    <span className="text-[#A19D94]">{n.author}</span>
                    <span className="text-[#66635C]">{n.date}</span>
                  </div>
                </Link>
              </Rise>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
